<template>
	<div>
		<Loader :show="loading" type="inline" />

		<div class="d-flex justify-content-end">
			<div class="btn btn-primary" @click="open()">Agregar cuenta</div>
		</div>

		<div class="item" v-for="item in list" :key="item.id" @click="open(item)">
			<h5>{{ item.name }}</h5>
			<p>
				{{ item.document }}<br />
				<span v-if="item.bank">{{ item.bank.name }}</span> -
				<span v-if="item.type == 'CA'">Caja de ahorro</span>
				<span v-if="item.type == 'CC'">Cuenta corriente</span>
				<br />
				Número de cuenta {{ item.number }}
			</p>
		</div>

		<div class="alert alert-default text-center mt-3" v-if="!loading && list.length == 0">
			Agrega una cuenta bancaria para poder retirar tu dinero.
		</div>

		<b-modal id="bankAccountModal" :title="title" no-close-on-backdrop hide-footer>
			<Loader :show="saving" />

			<FormulateForm v-if="!loading" v-model="form" ref="form" @submit="save">
				<FormulateInput
					label="Nombre y apellido del titular"
					name="name"
					validation-name="Nombre y apellido del titular"
					validation="required"
				/>
				<FormulateInput label="Documento" name="document" validation-name="Documento" validation="required" />

				<FormulateInput
					label="Banco"
					type="select"
					name="bankId"
					validation-name="Banco"
					validation="required"
					:options="banks"
					:disabled="action != 'create'"
					:class="{ disabled: action != 'create' }"
				/>

				<FormulateInput
					label="Número de cuenta"
					name="number"
					validation-name="Número de cuenta"
					validation="required"
				/>

				<FormulateInput
					label="Tipo de cuenta"
					type="select"
					name="type"
					validation-name="Tipo de cuenta"
					validation="required"
					:options="[
						{ value: 'CA', label: 'Caja de ahorro' },
						{ value: 'CC', label: 'Cuenta corriente' }
					]"
				/>

				<hr />

				<div class="d-flex justify-content-between mt-4">
					<FormulateInput type="button" data-ghost @click="close">Cancelar</FormulateInput>
					<FormulateInput type="button" disabled v-if="saving"
						>Guardando <span class="loader"
					/></FormulateInput>
					<FormulateInput type="submit" label="Guardar" v-else />
				</div>
			</FormulateForm>
		</b-modal>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "BankAccounts",

	props: {
		canCreate: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			list: [],
			loading: true,
			title: "Agregar cuenta bancaria",
			action: "create",
			form: {
				id: null,
				name: null,
				document: null,
				bankId: null,
				number: null,
				type: "CA"
			},
			banks: []
		}
	},

	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},

	methods: {
		async open(item) {
			this.loading = true

			if (item) {
				this.title = "Editar cuenta bancaria"
				this.action = "update"
				this.form = {
					id: item.id,
					name: item.name,
					document: item.document,
					bankId: item.bank.id,
					number: item.number,
					type: item.type
				}
			} else {
				this.form = {
					id: null,
					name: null,
					document: null,
					bank: null,
					number: null,
					type: "CA"
				}
			}

			this.$bvModal.show("bankAccountModal")
			this.loading = false
		},
		close() {
			this.$bvModal.hide("bankAccountModal")
			this.form = {
				id: null,
				name: null,
				document: null,
				bankId: null,
				number: null,
				type: "CA"
			}
		},
		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					name: this.form.name,
					document: this.form.document,
					bankId: this.form.bankId,
					number: this.form.number,
					type: this.form.type
				}

				if (this.action == "create") await this.create(data)
				if (this.action == "update") await this.update(data)
				this.load()
				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: BankAccountInput!) {
							bankAccountCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Cuenta bancaria creada correctamente")
					this.close()
					return data.bankAccountCreate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		async update(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: BankAccountInput!) {
							bankAccountUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.form.id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Cuanta bancaria editada correctamente")
					this.close()
					return data.bankAccountUpdate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							bankAccounts(take: $take, skip: $skip, search: $search) {
								data {
									id
									name
									document
									bank {
										id
										name
									}
									number
									type
								}
								pageInfo {
									totalItems
								}
							}
							banks {
								id
								name
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.list = data.bankAccounts.data
					this.pagination.pageInfo = data.bankAccounts.pageInfo

					this.banks = data.banks.map((b) => {
						return {
							value: b.id,
							label: b.name
						}
					})
					this.form.bankId = this.banks[0].value
					this.loading = false
				})
		}

		// deletePrompt(item) {
		// 	this.$dialog.confirm("¿Está seguro que desea eliminar este item?").then(() => {
		// 		this.delete(item)
		// 	})
		// },

		// delete(item) {
		// 	item.loading = true
		// 	this.$apollo
		// 		.mutate({
		// 			mutation: gql`
		// 				mutation($id: ID!) {
		// 					bankAccountDelete(id: $id) {
		// 						id
		// 					}
		// 				}
		// 			`,
		// 			variables: {
		// 				id: item.id
		// 			}
		// 		})
		// 		.then(() => {
		// 			this.$toast.success("Elemento eliminado correctamente")
		// 			this.load()
		// 		})
		// 		.catch((error) => {
		// 			this.errors = this.parseGQLErrors(error)
		// 			item.loading = false
		// 		})
		// }
	}
}
</script>

<style scoped lang="scss">
.item {
	padding: 8px 12px;
	border-bottom: 1px solid #f3f3f3;
	cursor: pointer;
	border-radius: 4px;
	margin-top: 4px;

	h5 {
		font-size: 1.1rem;
		font-weight: 500;
		margin: 0px;
	}

	p {
		font-size: 0.85rem;
		line-height: 0.9rem;
		color: #999;
		margin: 0px;
		font-weight: 300;
	}

	&:hover {
		background-color: #f3f3f3;
	}
}
</style>
